import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
const PreorderCheckoutWrapperLazy = React.lazy(
  () => import('./pages/Preorder/CheckoutPageWrapper')
);
const OnlineOrderCheckoutWrapperLazy = React.lazy(
  () => import('./pages/Preorder/OnlineOrderCheckoutWrapper')
);
const OnlineShopCheckoutWrapperLazy = React.lazy(
  () => import('./pages/OnlineShop/OnlineShopCheckoutWrapper')
);
import { HomePage } from './pages/HomePage';
import { MemberApp } from './pages/Member/App';
import { PreorderApp } from './pages/Preorder/App';
import { OnlineShopApp } from './pages/OnlineShop/App';
import { SurveyApp } from './pages/Survey/App';
import { PickupApp } from './pages/Pickup/App';
import { LiteApp } from './pages/Lite/App';
import { UnboundLanding } from './pages/UnboundLanding/UnboundLanding';
import { RegisterPage } from './pages/Register/RegisterPage';
import { NewSquarePage } from './pages/Lite/NewSquarePage';
import { OAuthReturnPage } from './pages/Lite/OAuthReturnPage';
import { SquareChoicePage } from './pages/Lite/SquareChoicePage';
import { SquareCreatePage } from './pages/Lite/SquareCreatePage';
import { SquareEnterPage } from './pages/Lite/SquareEnterPage';
import { SquareLandingPage } from './pages/Lite/SquareLandingPage';
import { HoldPage } from './pages/Lite/HoldPage';
import { JoinPage } from './pages/Lite/JoinPage';
import { ActivityDeliverPage } from './pages/Lite/ActivityDeliverPage';
import { ActivityResultPage } from './pages/Lite/ActivityResultPage';
import { SubscriptionPlanPage } from './pages/Lite/SubscriptionPlanPage';
import { SettingPage } from './pages/Lite/SettingPage';
import { ShortRedirectPage } from './pages/Lite/ShortRedirectPage';
import { ContextResolutionGuard } from './components/ContextResolutionGuard';

/**
 * 路由配置
 * 定義所有應用程式的路由
 */
export function Router() {
  console.log('[Router] 路由組件渲染');
  return (
    <Routes>
      {/* 未綁定群組引導頁（不需要 Context Resolution Guard） */}
      <Route path="/unbound" element={<UnboundLanding />} />

      {/* 活動短網址（前端網域 /g/:shortCode，向後端解析後轉址） */}
      <Route path="/g/:shortCode" element={<ShortRedirectPage />} />

      {/* 正式版登入綁定頁面（不需要 Context Resolution Guard） */}
      <Route path="/lite/register" element={<RegisterPage />} />
      {/* Lite Square：先登入 → 選擇新建/進入 → OAuth 回調、依後綴進入、Square 報名（不走 LIFF） */}
      <Route path="/lite/new-square" element={<NewSquarePage />} />
      <Route path="/lite/oauth-return" element={<OAuthReturnPage />} />
      <Route path="/lite/square-choice" element={<SquareChoicePage />} />
      <Route path="/lite/square-create" element={<SquareCreatePage />} />
      <Route path="/lite/square-enter" element={<SquareEnterPage />} />
      <Route
        path="/lite/shop/:suffix/join/:activityId"
        element={<JoinPage />}
      />
      {/* 建立活動：Group 與 Square 共用 HoldPage（草稿、可收合項目） */}
      <Route path="/lite/shop/:suffix/create-activity" element={<HoldPage />} />
      {/* 活動交付：Group 與 Square 共用 ActivityDeliverPage / ActivityResultPage */}
      <Route
        path="/lite/shop/:suffix/deliver/:activityId"
        element={<ActivityDeliverPage />}
      />
      <Route
        path="/lite/shop/:suffix/deliver/:activityId/result"
        element={<ActivityResultPage />}
      />
      <Route
        path="/lite/shop/:suffix/subscription"
        element={<SubscriptionPlanPage />}
      />
      <Route path="/lite/shop/:suffix/setting" element={<SettingPage />} />
      <Route path="/lite/shop/:suffix" element={<SquareLandingPage />} />
      {/* 保留舊路由以支援重定向 */}
      <Route
        path="/register"
        element={<Navigate to="/lite/register" replace />}
      />

      {/* 其他路由需要 Context Resolution Guard */}
      <Route
        path="/*"
        element={
          <ContextResolutionGuard>
            <Routes>
              {/* 首頁 - 租戶網站（mock） */}
              <Route path="/" element={<HomePage />} />

              {/* 會員中心 */}
              <Route path="/member" element={<MemberApp />} />

              {/* 預購功能 */}
              <Route path="/preorder" element={<PreorderApp />} />
              <Route
                path="/preorder/checkout"
                element={
                  <React.Suspense fallback={null}>
                    <PreorderCheckoutWrapperLazy />
                  </React.Suspense>
                }
              />
              {/* 線上訂單結帳（獨立頁面：內用／外帶，無取貨日期） */}
              <Route
                path="/online-order/checkout"
                element={
                  <React.Suspense fallback={null}>
                    <OnlineOrderCheckoutWrapperLazy />
                  </React.Suspense>
                }
              />
              <Route
                path="/preorder/payment/return"
                element={<PreorderApp />}
              />
              <Route
                path="/preorder/payment/cancel"
                element={<PreorderApp />}
              />
              {/* 線上商店／線上訂單（共用 OnlineShopApp，商品來源＝商品管理；與 /preorder 分離） */}
              <Route path="/online-shopping" element={<OnlineShopApp />} />
              <Route path="/online-order" element={<OnlineShopApp />} />
              {/* 線上商店結帳：取貨 → 發票 → 付款（3 步） */}
              <Route
                path="/online-shopping/checkout"
                element={
                  <React.Suspense fallback={null}>
                    <OnlineShopCheckoutWrapperLazy />
                  </React.Suspense>
                }
              />

              {/* 問卷調查 */}
              <Route path="/survey" element={<SurveyApp />} />

              {/* 取貨功能 */}
              <Route path="/pickup" element={<PickupApp />} />

              {/* Lite 購買清單功能 */}
              <Route path="/lite/*" element={<LiteApp />} />

              {/* 預設重定向到首頁 */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ContextResolutionGuard>
        }
      />
    </Routes>
  );
}
